import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Spinner,
} from '@blueprintjs/core';

import { getRelease } from 'actions/iap';
import CreateRelease from './create_release';

class EditRelease extends Component {
  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getRelease(match.params.id));
  }

  render() {
    const { release } = this.props;
    if (!release.data || !!release.pending) {
      return <Spinner size={100} />;
    }

    const initialValues = {
      ...release.data,
      devices: release.data.devices.map(x => ({ device: x })),
    };

    return (
      <CreateRelease
        isEdit
        title={`IAP Release v${release.data.version}`}
        initialValues={initialValues}
        releaseId={release.data.id}
      />
    );
  }
}


EditRelease.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  release: PropTypes.object,
};

export default connect(state => ({
  release: state.iap.release,
}))(EditRelease);
